import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/buda")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Buda, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Buda & Hays County. Free quotes — +1 (830) 390-9588.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Buda, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Buda and Hays County.",
      keywords: "awnings Buda, awning company Buda, custom awnings Buda, sail shades Buda, patio covers Buda, pergola covers Buda, metal awnings Buda, canvas awnings Buda, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Buda", "Hays County"),
  }),
  component: () => <CityHomePage city="Buda" region="Hays County" />,
});
